// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: '',
  user: localStorage.getItem('user') || '',
  tableList: []
}
